(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearResultAgreementNewController", LebaniegoYearResultAgreementNewController);

        LebaniegoYearResultAgreementNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "$http",
        "$state",
        "$mdSidenav",
        "$q",
        "entity",
        "LebaniegoYearResultAgreement",
        "previousState",
        "toastr",
        "DateUtils",
    ]

    function LebaniegoYearResultAgreementNewController(
        $rootScope,
        $timeout,
        $scope,
        $http,
        $state,
        $mdSidenav,
        $q,
        entity,
        LebaniegoYearResultAgreement,
        previousState,
        toastr,
        DateUtils
    ) {
        var vm = this;

        vm.lebaniegoYearResultAgreement = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearResultAgreementParameters")
        );
        
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearResultAgreement = Object.assign({}, vm.lebaniegoYearResultAgreement);
            lebaniegoYearResultAgreement.id = null;
            lebaniegoYearResultAgreement.year = vm.lebaniegoYearResultAgreement.year;
            lebaniegoYearResultAgreement.sector = 'CONVENIO';
            vm.lebaniegoYearResultAgreement.gFile = {
                id: vm.lebaniegoYearResultAgreement.gFile
            };
            lebaniegoYearResultAgreement.gFile = vm.lebaniegoYearResultAgreement.gFile;
            LebaniegoYearResultAgreement.save(lebaniegoYearResultAgreement, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-result-agreement", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el convenio");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/ly-result/g-file/search?searchText=' + searchText + '&jurisdiction=AÑO_LEBANIEGO_CONVENIO')
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.lebaniegoYearResultAgreement.businessName = item.sectorBusinessName;
                vm.lebaniegoYearResultAgreement.gFile = item.gFileId;
            }
        }
    }
})();